import { useEffect } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import ArticlesSection from "./components/ArticlesSection";
import AboutSection from "./components/AboutSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://acbuy2026.net";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      "url": SITE_URL,
      "name": "ACBuy Spreadsheet 2026",
      "description": "The most comprehensive replica shopping database. 100,000+ verified products, QC photos, hipobuy shipping coupons, haul guides and more.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${SITE_URL}/?s={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      "name": "ACBuy Spreadsheet 2026",
      "url": SITE_URL,
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/751042991eee80e3d0f5ce87d83ca658/767f58c2250624902df30344d9bb9bad.png"
      },
      "sameAs": ["https://repsw2c.com/"]
    },
    {
      "@type": "WebPage",
      "@id": `${SITE_URL}/#webpage`,
      "url": SITE_URL,
      "name": "ACBuy Spreadsheet 2026 | Best Hipobuy Spreadsheet Alternative",
      "isPartOf": { "@id": `${SITE_URL}/#website` },
      "about": { "@id": `${SITE_URL}/#organization` },
      "description": "ACBuy Spreadsheet 2026 — the most comprehensive replica shopping database. Better than hipobuy spreadsheet 2026. 100,000+ verified products, QC photos, hipobuy shipping coupons, haul guides and more.",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": SITE_URL
          }
        ]
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is the ACBuy Spreadsheet 2026?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The ACBuy Spreadsheet 2026 is a community-curated database of 100,000+ replica products with verified seller links, QC photos, and shipping information — the best hipobuy spreadsheet alternative available."
          }
        },
        {
          "@type": "Question",
          "name": "How does ACBuy Spreadsheet compare to hipobuy spreadsheet 2026?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "ACBuy Spreadsheet 2026 offers more frequent updates, a larger product database, and better QC photo integration compared to the hipobuy spreadsheet 2026."
          }
        },
        {
          "@type": "Question",
          "name": "How do I find hipobuy shipping coupons?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Hipobuy shipping coupons can be found through community forums, seasonal sales events, and first-order discounts. The ACBuy Spreadsheet 2026 also lists current shipping promotions."
          }
        },
        {
          "@type": "Question",
          "name": "What is the hipobuy QC finder?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The hipobuy QC finder is a tool that lets you search for quality control photos by product name, seller, or item code, helping you make informed purchasing decisions."
          }
        }
      ]
    }
  ]
};

export default function Home() {
  useEffect(() => {
    const existingScript = document.getElementById("home-jsonld");
    if (existingScript) existingScript.remove();
    const script = document.createElement("script");
    script.id = "home-jsonld";
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(homeJsonLd);
    document.head.appendChild(script);
    return () => {
      const s = document.getElementById("home-jsonld");
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <CategoriesSection />
      <ArticlesSection />
      <AboutSection />
      <FAQSection />
      <CTASection />
      <FooterSection />
    </div>
  );
}
